export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('table_title_plan_order_no') || '生产计划编号',
    field: 'planOrderNo',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_order_no') || '订单编号',
    field: 'orderNo',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },

  {
    title: that.$l('table_label_planned_start_date') || '计划开始日期',
    field: 'beginDate',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_planned_end_date') || '计划结束日期',
    field: 'endDate',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_plan_status') || '计划状态',
    width: 100,
    align: 'center',
    slots: { default: 'status' }
  },
  {
    title: that.$l('table_label_total_planned_quantity') || '总计划数量',
    field: 'planQty',
    minWidth: 100,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_total_scheduled_production') || '已排产总数',
    field: 'schedulingQty',
    minWidth: 100,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_total_completed') || '已完成总数',
    field: 'finishQty',
    minWidth: 100,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_reviewer_by_name') || '审核人',
    field: 'reviewByName',
    minWidth: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'reviewInfo' }
  },
  {
    title: that.$l('INDEX.creator') || '创建人',
    field: 'createByName',
    minWidth: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'createInfo' }
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    minWidth: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' }
  },
]
